export default {
  s: '%d секунда',
  smicro: '%d с',
  smid: '%d сек',

  ss: '%d секунд',
  ssfew: '%d секунди',
  ssmicro: '%d с',
  ssmid: '%d сек',

  m: '%d хвилина',
  mmicro: '%d хв',
  mmid: '%d хв',

  mm: '%d хвилин',
  mmfew: '%d хвилини',
  mmmicro: '%d хв',
  mmmid: '%d хв',

  h: '%d година',
  hmicro: '%d год',
  hmid: '%d година',

  hh: '%d годин',
  hhfew: '%d години',
  hhmicro: '%d год',
  hhmid: '%d годин',
  hhmidfew: '%d години',

  d: '%d день',
  dmicro: '%d д',
  dmid: '%d день',

  dd: '%d днів',
  ddfew: '%d дні',
  ddmicro: '%d д',
  ddmid: '%d днів',
  ddmidfew: '%d дні',
};
